import React, { useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import NexodataReceitas from './NexodataReceitas';
import { setAuthorizationHeader } from '../shared/api';
import { getPathname } from '../helpers/getPathname';
import baseRoutes from '../router/routes';
import cookieAuthRoutes from '../router/cookieAuthRoutes';
import errorRoutes from '../router/errorRoutes';
import Errors from '../containers/Errors/Errors';

const versionRoutes = [
  {
    path: '/v2/*',
    component: NexodataReceitas,
    routes: baseRoutes,
  },
  {
    path: '/v3/*',
    component: NexodataReceitas,
    routes: cookieAuthRoutes,
  },
];

export default function VersionRouter() {
  const history = useHistory();

  useEffect(() => {
    const pathname = getPathname();

    if (errorRoutes.map((route) => route.path).includes(pathname)) return;

    const isInVersion1 = pathname.includes('prescricao');

    if (isInVersion1) {
      const parts = pathname.split('/').filter((part) => !!part);

      if (Array.isArray(parts) && parts.length >= 3) {
        setAuthorizationHeader(parts[2]);
      }
    }

    if (pathname.includes('v2') || pathname.includes('v3')) {
      return;
    }

    const targetLocation = pathname.replace('prescricao', 'prescription');

    history.push(`/v2${targetLocation}`);
  }, [history]);

  return (
    <Switch>
      {versionRoutes.map((version, index) => {
        const Component = version.component;
        return (
          <Route path={version.path} key={index}>
            <Component routes={version.routes} />
          </Route>
        );
      })}

      <Errors />
    </Switch>
  );
}
